import { atom } from 'jotai';
import { CURRENT_DATE, ONE_WEEK_AGO } from './DateRangePicker/constants';

export const selectedPixelIdAtom = atom<string | undefined>(undefined);

export const selectedDateRangeAtom = atom<{ from?: Date; to?: Date }>({
  from: ONE_WEEK_AGO,
  to: CURRENT_DATE,
});
